lmApp
  .controller('MonitoringWidgetController', ['$scope', '$rootScope', '$timeout', 'InfrastructureService', function ($scope, $rootScope, $timeout, InfrastructureService) {
    $scope.controls = {
      range: '1h',
      stepDiv: 720,
      end: 0,
      endDate: null,
      endTime: moment().diff(moment().startOf('day'), 'seconds')
    };

    $scope.widgetData = {
      widgetReloading: false,
      showControls: false
    };

    $scope.colors = ['#4caf50', '#f44336', '#2196f3', '#ff9800', '#6a1b9a', '#283593', '#e64a19', '#37474f'];

    $scope.getColor = function (index) {
      return $scope.colors[index - $scope.colors.length * Math.floor(index / $scope.colors.length)];
    };

    $scope.parseRange = function (string) {
      var tokens = {
        m: 60,
        h: 60 * 60,
        d: 60 * 60 * 24,
        w: 60 * 60 * 64 * 7,
        y: 60 * 60 * 64 * 7 * 52
      };

      var seconds = 0;

      var y = string.match(/(\d+)*y/);
      var w = string.match(/(\d+)*w/);
      var d = string.match(/(\d+)*d/);
      var h = string.match(/(\d+)*h/);
      var m = string.match(/(\d+)*m/);
      if (y)  seconds += parseInt(y[1]) * tokens.y;
      if (w)  seconds += parseInt(w[1]) * tokens.w;
      if (d) seconds += parseInt(d[1]) * tokens.d;
      if (h) seconds += parseInt(h[1]) * tokens.h;
      if (m) seconds += parseInt(m[1]) * tokens.m;

      return seconds;
    };

    /**
     * Make X Axis depends on Data
     */
    var make_x_axis = function (xRange) {
      return d3.svg.axis()
        .scale(xRange)
        .orient('bottom')
        .ticks(5);
    };

    /**
     * Make Y Axis depends on Data
     */
    var make_y_axis = function (yRange) {
      return d3.svg.axis()
        .scale(yRange)
        .orient('left')
        .ticks(5)
    };

    var bisectDate = d3.bisector(function (d) {
      return d.x;
    }).left;

    $scope.getInitData = function () {

      $rootScope.showLinearProgress('#monitoringWidgetLoader_' + $scope.id);
      InfrastructureService.monitoringRequest($scope.expr, $scope.parseRange($scope.controls.range), Math.floor($scope.parseRange($scope.controls.range) / $scope.controls.stepDiv), $scope.controls.end)
        .then(function (response) {
          console.log(response);

          if (response.type === 'matrix') {
            var metrics = _.map(response.value, 'metric.' + $scope.label);

            $scope.series = {};

            _.forEach(response.value, function (series, index) {
              $scope.series[_.get(series, 'metric.' + $scope.label)] = {
                color: $scope.getColor(index),
                label: metrics[index] || ''
              }
            });

            $scope.data = _.map(_.map(response.value, 'values'), function (datas, index) {
              return _.map(datas, function (data) {
                return {
                  x: data[0] * 1000,
                  y: +data[1] * 2,
                  humanX: moment.utc(data[0] * 1000),
                  series: metrics[index]
                };
              }).sort(function (a, b) {
                return a.x - b.x;
              });
            });

            //$scope.labels = _.map(_.map(response.value, 'values')[0], function (label) {
            //  return moment(label[0] * 1000).format('MMMM Do YYYY, h:mm:ss a');
            //});

          }

          $rootScope.hideLinearProgress('#monitoringWidgetLoader_' + $scope.id);
        })
        .catch(function (reason) {
          $rootScope.hideLinearProgress('#monitoringWidgetLoader_' + $scope.id);

          console.error(reason);
        });
    };

    $scope.updateData = function () {

      InfrastructureService.monitoringRequest($scope.expr, $scope.parseRange($scope.controls.range), Math.floor($scope.parseRange($scope.controls.range) / $scope.controls.stepDiv), $scope.controls.end)
        .then(function (response) {

          if (response.type === 'matrix') {
            var metrics = _.map(response.value, 'metric.' + $scope.label);

            $scope.series = {};

            _.forEach(response.value, function (series, index) {
              $scope.series[_.get(series, 'metric.' + $scope.label)] = {
                color: $scope.getColor(index),
                label: metrics[index] || ''
              }
            });

            $scope.data = _.map(_.map(response.value, 'values'), function (datas, index) {
              return _.map(datas, function (data) {
                return {
                  x: data[0] * 1000,
                  y: +data[1],
                  humanX: moment.utc(data[0] * 1000),
                  series: metrics[index]
                };
              });
            });
          }

        })
        .catch(function (reason) {
          console.error(reason);
        });
    };

    /**
     *
     * @type {*|(function(newValue: Array, oldValue: Array))|Function}
     */
    $scope.watcherControl = $scope.$watchCollection('controls', function (newValue /** Array **/, oldValue) {
      if (_.isEqual(oldValue, newValue)) return;

      if (newValue.endDate) {
        $scope.controls.end = newValue.endDate.unix() + newValue.endTime;
      }
    });

    /**
     *
     * @type {*|(function(newValue: Array, oldValue: Array))|Function}
     */
    $scope.watcherData = $scope.$watch('data', function (newValue /** Array **/, oldValue) {

      if (!newValue) return;

      d3.selectAll('#monitoring_widget_' + $scope.id + ' > svg > *').remove();

      $scope.noData = !newValue.length;

      $timeout(function () {
        $scope.widgetData.widgetReloading = true;
      });

      var realHeight = $scope.sizes.HEIGHT - $scope.sizes.MARGINS.top - $scope.sizes.MARGINS.bottom;

      var realWidth = $scope.sizes.WIDTH - $scope.sizes.MARGINS.left - $scope.sizes.MARGINS.right;


      var lineFunc = d3.svg.line()
        .x(function (d) {
          return xRange(d.x);
        })
        .y(function (d) {
          return yRange(d.y);
        })
        .interpolate('linear');

      var xRange = d3.time.scale().range([$scope.sizes.MARGINS.left, $scope.sizes.WIDTH - $scope.sizes.MARGINS.right]);

      var yRange;
      if ($scope.logY) {
        yRange = d3.scale.log().clamp(true).range([$scope.sizes.HEIGHT - $scope.sizes.MARGINS.top, $scope.sizes.MARGINS.bottom]);

      } else {
        yRange = d3.scale.linear().range([$scope.sizes.HEIGHT - $scope.sizes.MARGINS.top, $scope.sizes.MARGINS.bottom]);
      }

      var minX = d3.min(newValue, function (kv) {
        return d3.min(kv, function (d) {
          return d.x;
        });
      });
      var maxX = d3.max(newValue, function (kv) {
        return d3.max(kv, function (d) {
          return d.x;
        });
      });
      var minY = d3.min(newValue, function (kv) {
        return d3.min(kv, function (d) {
          return d.y;
        });
      });
      var maxY = d3.max(newValue, function (kv) {
        return d3.max(kv, function (d) {
          return d.y;
        });
      });

      xRange.domain([minX, maxX]);
      yRange.domain([0.000001, maxY]).nice();

      /**
       * AXIS
       */
      var xAxis = d3.svg.axis()
        .scale(xRange)
        .tickSize(1);

      var yAxis = d3.svg.axis()
        .scale(yRange)
        .tickSize(1)
        .orient('left');

      if ($scope.logY) {
        yAxis.ticks(0, "e")
          .tickFormat(function (d) {
            var log = Math.log(d) / Math.LN10;
            return Math.abs(Math.round(log) - log) < 1e-6 ? d : '';
          });
      }

      /**
       * DRAW GRID
       */
      $scope.canvas.append('g')
        .attr('class', 'grid')
        .attr('height', realHeight)
        .attr('width', realWidth)
        .attr('transform', 'translate(0,' + ($scope.sizes.HEIGHT - $scope.sizes.MARGINS.bottom) + ')')
        .call(make_x_axis(xRange)
          .tickSize(-realHeight, 0, 0)
          .tickFormat('')
        );

      $scope.canvas.append('g')
        .attr('class', 'grid')
        .attr('height', realHeight)
        .attr('width', realWidth)
        .attr('transform', 'translate(' + ($scope.sizes.MARGINS.left) + ',0)')
        .call(make_y_axis(yRange)
          .tickSize(-$scope.sizes.WIDTH, 0, 0)
          .tickFormat('')
        );

      $scope.canvas.append('svg:rect')  // Grid lines Bakcground
        .attr('x', 0)
        .attr('y', 0)
        .attr('transform', 'translate(' + ($scope.sizes.MARGINS.left) + ',' + ($scope.sizes.MARGINS.top) + ')')
        .attr('height', realHeight)
        .attr('width', $scope.sizes.WIDTH)
        .attr('fill', '#E6E6E6')
        .style('opacity', '0.2');

      /**
       * DRAW AXIS
       */
      $scope.canvas.append('svg:g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + ($scope.sizes.HEIGHT - $scope.sizes.MARGINS.bottom) + ')')
        .call(xAxis);

      $scope.canvas.append('svg:g')
        .attr('class', 'y axis')
        .attr('transform', 'translate(' + ($scope.sizes.MARGINS.left) + ',0)')
        .call(yAxis);

      $scope.container
        .on('mouseover', function (d) {
          $scope.tooltip
            .style('left', 0)
            .style('top', $scope.sizes.MARGINS.top + 'px')
            .style('opacity', 1)
            .style('height', realHeight + 'px');

          $scope.tooltip_dot
            .style('display', 'block');

          $scope.tooltip_item
            .style('opacity', 1);
        })
        .on('mousemove', function (e) {
          var coords = d3.mouse(this);
          var x0 = xRange.invert(coords[0]);
          var y0 = yRange.invert(coords[1]);

          var ds = $scope.data.map(function (e) {
            var i = bisectDate(e, x0, 1);
            var d0 = e[i - 1];
            var d1 = e[i];
            return x0 - d0.x > d1.x - x0 ? d1 : d0;
          });

          var distanceOld, distanceNew, d;
          if (ds.length) {
            distanceOld = Math.sqrt((ds[0].x - x0.getTime()) * (ds[0].x - x0.getTime()) + (ds[0].y - y0) * (ds[0].y - y0));
            d = [ds[0]];
          }

          for (var i = 0; i < ds.length; i++) {

            distanceNew = Math.sqrt((ds[i].x - x0.getTime()) * (ds[i].x - x0.getTime()) + (ds[i].y - y0) * (ds[i].y - y0));
            if (distanceNew < distanceOld) {
              d = [ds[i]];
              distanceOld = distanceNew;
            }
          }

          for (var i = 0; i < ds.length; i++) {

            if (ds[i].y === d[0].y && ds[i].series !== d[0].series) {
              d.push(ds[i]);
            }
          }

          $scope.tooltip
            .style('left', (xRange(x0)) + 'px');

          $scope.tooltip_text.style('right', '').style('left', '');
          if (xRange(x0) > $scope.canvas.node().getBoundingClientRect().width - $scope.tooltip_text.node().offsetWidth) {
            $scope.tooltip_text.style('left', -$scope.tooltip_text.node().offsetWidth + 'px');
          }

          $scope.tooltip_text
            .text(moment.utc(x0).format('ddd, MMMM Do YYYY, h:mm:ss a'));

          if (d) {
            $scope.tooltip_dot
              .style('display', 'block')
              .style('border-color', $scope.series[d[0].series].color)
              .style('top', (yRange(d[0].y) - $scope.sizes.MARGINS.top) + 'px');

            var tooltipItemText = d.map(function (item) {
              return '<div><span class="fs-subhead" style="color:' + $scope.series[item.series].color + ';">' + item.series + '</span><br/><span>' + item.y + '</span></div>';
            });

            $scope.tooltip_item
              .style('top', (yRange(d[0].y) - $scope.tooltip_item.node().offsetHeight / 2) + 'px')
              .html(tooltipItemText.join(''));

            $scope.tooltip_item.style('right', '').style('left', '');
            if (xRange(x0) > $scope.canvas.node().getBoundingClientRect().width - $scope.tooltip_item.node().offsetWidth) {
              $scope.tooltip_item.style('left', -$scope.tooltip_item.node().offsetWidth - 10 + 'px');
            } else {
              $scope.tooltip_item.style('left', 10 + 'px');
            }

            //$scope.tooltip_item.style('top', $scope.tooltip_item.node().offsetHeight / 2 + 'px');

            /* Check if tooltip is overlap Date on top */
            var extraMargin = 18 + 6; // 12px (line height) + 6px (to create some extra distance)
            if (($scope.tooltip_text.node().offsetHeight + extraMargin) > parseFloat($scope.tooltip_item.node().style.top)) {
              $scope.tooltip_item.style('top', $scope.tooltip_text.node().offsetHeight + extraMargin + 'px');
            }
          }
        })
        .on('mouseout', function (d) {
          $scope.tooltip
            .style('opacity', 0);

          $scope.tooltip_dot
            .style('display', 'none');

          $scope.tooltip_item
            .style('opacity', 0);
        });

      newValue.forEach(function (partData, index) {

        $scope.canvas.append('svg:path')
          .attr('d', lineFunc(partData))
          .attr('stroke', $scope.getColor(index))
          .attr('stroke-width', 1.5)
          .attr('fill', 'none');

      });

      $timeout(function () {
        $scope.widgetData.widgetReloading = false;
      })

    })

  }]);

lmApp
  .directive('lmMonitoringWidget', ['$timeout', '$interval', '$window', function ($timeout, $interval, $window) {
    return {
      restrict: 'E',
      scope: {
        id: '@',
        title: '@',
        type: '@',
        expr: '@',
        label: '@',
        isLive: '@',
        zeroY: '=',
        logY: '='
      },
      controller: 'MonitoringWidgetController',
      link: function (scope, element) {
        scope.expr = scope.expr.replace(/'/g, '"');

        scope._resizeWidget = function () {
          scope.sizes = {
            WIDTH: element.find('div#monitoring_widget_' + scope.id).outerWidth(),
            HEIGHT: 500,
            MARGINS: {
              top: 20,
              right: 0,
              bottom: 20,
              left: 50
            }
          };

          scope.canvas
            .attr('height', scope.sizes.HEIGHT)
            .attr('width', scope.sizes.WIDTH);

          scope.updateData();
        };


        $timeout(function () {
          scope.sizes = {
            WIDTH: element.find('div#monitoring_widget_' + scope.id).outerWidth(),
            HEIGHT: 500,
            MARGINS: {
              top: 20,
              right: 0,
              bottom: 20,
              left: 50
            }
          };

          scope.container = d3.select('div#monitoring_widget_' + scope.id);

          scope.canvas = scope.container.append('svg')
            .attr('height', scope.sizes.HEIGHT)
            .attr('width', scope.sizes.WIDTH);

          /**
           * Details Line
           **/
          scope.tooltip = scope.container.select('#details');

          /**
           * Details Text
           **/
          scope.tooltip_text = scope.tooltip.select('#x_details');
          scope.tooltip_dot = scope.tooltip.select('#dot_details');
          scope.tooltip_item = scope.tooltip.select('#item_details');

          scope.getInitData();
        });

        if (+scope.isLive) scope.reload = $interval(function () {
          scope.updateData();
        }, +scope.isLive);

        angular.element($window).bind('resize', scope._resizeWidget);

        element.on('$destroy', function () {
          if (scope.isLive && scope.reload) $interval.cancel(scope.reload);
          scope.watcherData();
          scope.watcherControl();
          angular.element($window).unbind('resize', scope._resizeWidget);
        });
      },
      templateUrl: 'lm-monitoring-widget/monitoring-widget.tpl.html'
    };
  }]);
